<template>
  <div class="left-sidenav">
    <!-- LOGO -->
    <div class="brand">
      <router-link to="/" class="logo">
        <span>
          <img src="../assets/logo.png" alt="logo-large" class="logo-lg logo-light">
        </span>
      </router-link>
    </div>
    <!--end logo-->
    <div class="menu-content h-100" data-simplebar>
      <ul class="metismenu left-sidenav-menu">
        <li :class="((item.active||checkChildrenActive(index))?'active':'')" v-for="(item,index) in menus" :key="index">
          <router-link :class="(item.active?'active':'')" v-if="!item.children || !item.children.length" :to="item.href">
            <i :class="'align-self-center menu-icon far fa-'+item.icon"></i>
            <span>{{ item.title }}
            <span class="d-none">{{ (currentUrl ===item.href.toLowerCase() || item.active?(item.active=true):(item.active=false)) }}</span>
            </span>
          </router-link>
          <a @click="parentMenuClick(index)" :class="(item.active?'active':'')"
             v-else-if="item.children && item.children.length">
            <i :class="'align-self-center menu-icon far fa-'+item.icon"></i>
            <span>{{ item.title }}</span>
            <span class="menu-arrow"><i :class="'far fa-angle-'+(item.active?'down':'left')"></i>
            </span>
          </a>
          <ul  v-if="item.children && item.children.length" :class="'nav-second-level '+(item.active?'d-block':'d-none')" aria-expanded="false">
            <li v-for="(child,index2) in item.children"
                :class="'nav-item '+((currentUrl === child.href.toLowerCase())?'active':'')">
              <router-link :class="'nav-link '+((currentUrl.toLowerCase() === child.href.toLowerCase())?'active':'')"
                           :to="child.href">
                <i :class="'fal ti-control-record  fa-'+child.icon"></i>{{ child.title }}
                <span class="d-none">{{ (currentUrl ===child.href.toLowerCase() || item.active?(item.active=true):(item.active=false)) }}</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "RightSidenav",
  data(){
    return{
      menus : [
        {
          title : 'برند محصولات',icon : 'tag',href :'',active : false,
          children : [
              {title : 'افزودن',icon : 'circle',href :'/ProductBrand/Add'},
              {title : 'لیست',icon : 'circle',href :'/ProductBrand/List'},
              ],
        },
        {
          title : 'مرکز کنترل',icon : 'tag',href: '/OperationsCenter',active: false
        },
        {
          title : 'ویژگی های محصولات',icon : 'tag',href: '/ProductAttribute/Manage',active: false
        },
        {
          title : 'مدیریت اشتراک ها',icon : 'tag',href: '',
          children : [
            {title : 'افزودن',icon : 'circle',href :'/Plan/Add'},
            {title : 'لیست',icon : 'circle',href :'/Plan/List'},
          ],
        },
        {
          title : 'مدیریت انواع پرداخت',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/PaymentType/Add'},
            {title : 'لیست',icon : 'circle',href :'/PaymentType/List'},
          ],
        },
        {
          title : 'مدیریت اصناف',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/Guild/Add'},
            {title : 'لیست',icon : 'circle',href :'/Guild/List'},
          ],
        },
        {
          title : 'دسته بندی محصولات',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/ProductCategory/Add'},
            {title : 'لیست',icon : 'circle',href :'/ProductCategory/List'},
          ],
        },
        {
          title : 'محصولات',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/Product/Add'},
            {title : 'لیست',icon : 'circle',href :'/Product/List'},
          ],
        },
        {
          title : 'دلایل کنسل کردن معامله ',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/cancelTransactionReason/Add'},
            {title : 'لیست',icon : 'circle',href :'/cancelTransactionReason/List'},
          ],
        },
        {
          title : 'دلایل رد پیشنهاد ',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/rejectOfferReason/Add'},
            {title : 'لیست',icon : 'circle',href :'/rejectOfferReason/List'},
          ],
        },
        {
          title : 'کاربران',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/User/Add'},
            {title : 'لیست',icon : 'circle',href :'/User/List'},
          ],
        },
        {
          title : 'دپارتمان تیکت',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/ticketDepartment/Add'},
            {title : 'لیست',icon : 'circle',href :'/ticketDepartment/list'},
          ],
        },
        {
          title : 'پیام ها',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/UserMessage/Add'},
            {title : 'لیست',icon : 'circle',href :'/UserMessage/List'},
          ],
        },
        {
          title : 'تیکت ها',icon : 'tag',href: '/Ticket/List',active: false,
        },
        {
          title : 'درخواست های ثبت برند',icon : 'tag',href: '/RequestRegisterBrand/List',active: false,
        },
        {
          title : 'درخواست های ثبت محصول',icon : 'tag',href: '/RequestRegisterProduct/List',active: false,
        },
        {
          title : 'درخواست های بازار',icon : 'tag',href: '/MarketRequest/List',active: false,
        },
        {
          title : 'درخواست های مزایده',icon : 'tag',href: '/AuctionRequest/List',active: false,
        },
        {
          title : 'مدیران',icon : 'tag',href: '',active: false,
          children : [
            {title : 'افزودن',icon : 'circle',href :'/Manager/Add'},
            {title : 'لیست',icon : 'circle',href :'/Manager/List'},
          ],
        },
        {
          title : 'تنظیمات',icon : 'cogs',href: '',active: false,
          children : [
            {title : 'صفحه راهنما',icon : 'circle',href :'/setting/learningPage'},
            {title : ' مودال قوانین و مقررات',icon : 'circle',href :'/setting/lawModal'},
            {title : 'قیمت سکه ها و نردبان',icon : 'circle',href :'/setting/coinCost'},
          ],
        },
        {
          title : 'تراکنش های بانکی',icon : 'tag',href: '/bankTransactions/List',active: false,
        },
        {
          title : 'تغییر کلمه عبور',icon : 'tag',href: '/changePassword',active: false,
        },
        {
          title : 'خروج',icon : 'tag',href: '/Logout',active: false,
        },
      ],
      currentUrl : (this.$route.path).toLowerCase()
    }
  },
  computed : {
    ...mapGetters('auth',{
      currentUser : 'getUserInfo',
      currentMenus: 'getMenus',
    }),
  },
  methods: {
    parentMenuClick(index)
    {
      const menus = this.menus;
      if (menus[index].active)
        menus[index].active = false;
      else
      {
        for (let i = 0;i<menus.length;i++)
        {
          menus[i].active = false;
        }
        menus[index].active = true;
        this.menus = menus
      }
    },
    checkChildrenActive(index)
    {
      const children = this.menus[index].children;
      if (children)
      {
          for (let i = 0;i<children.length;i++)
          {
            if (children[i].href.toLowerCase() === this.currentUrl)
              return true;
          }
      }
      return false;
    },
    closeAllMenu()
    {
      const menus = this.menus;
      for (let i = 0;i<menus.length;i++)
      {
        menus[i].active = false;
      }
    }
  },
  mounted()
  {
    this.menus = this.currentMenus;
  },
  watch:{
    '$route.path':{
      handler(path)
      {
        this.closeAllMenu();
        this.currentUrl = path.toLowerCase();
      }
    }
  }
}
</script>

<style scoped>
a
{
  text-decoration: none;
}
.left-sidenav .menu-content {
  overflow-y: auto;
}
.close_menu .left-sidenav
{
  min-width: 0;
  max-width: 0;
  overflow: hidden;
}
</style>